import { motion } from "framer-motion";
import {
  Scales,
  Briefcase,
  Eye,
  Lock,
  HandHeart,
  Compass,
  Medal,
  Target,
  GlobeHemisphereWest,
} from "@phosphor-icons/react";

const standards = [
  { icon: Scales, label: "Integrity" },
  { icon: Briefcase, label: "Professionalism" },
  { icon: Eye, label: "Transparency" },
  { icon: Lock, label: "Confidentiality" },
  { icon: HandHeart, label: "Respect" },
  { icon: Compass, label: "Business Ethics" },
  { icon: Medal, label: "Quality" },
  { icon: Target, label: "Commitment" },
  { icon: GlobeHemisphereWest, label: "Global Mindset" },
];

export default function Standards() {
  return (
    <section
      id="standards"
      data-testid="standards-section"
      className="py-24 md:py-32 bg-altin-bg"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="gold-divider" />
            <span className="overline">Our Standards</span>
            <span className="gold-divider" />
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl leading-[1.05] text-altin-ink tracking-tight">
            The values guiding{" "}
            <span className="italic text-altin-gold">every</span> engagement.
          </h2>
          <p className="mt-6 text-lg text-altin-muted font-light leading-relaxed">
            Nine non-negotiable business standards that define how we represent
            our clients, partners and our own firm.
          </p>
        </div>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-px bg-altin-border border border-altin-border max-w-5xl mx-auto">
          {standards.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.label}
                data-testid={`standard-${i}`}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.45, delay: (i % 3) * 0.08 }}
                className="group bg-altin-bg py-14 px-6 flex flex-col items-center text-center hover:bg-white transition-colors duration-300"
              >
                <div className="w-16 h-16 rounded-full grid place-items-center border border-altin-gold/60 text-altin-gold mb-5 group-hover:bg-altin-gold group-hover:text-white transition-colors duration-300">
                  <Icon size={26} weight="light" />
                </div>
                <div className="font-serif-display text-xl text-altin-ink tracking-tight">
                  {s.label}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
